type Constructor<T = {}> = new (...args: any[]) => T

import MCSUnit from 'src/mcs-unit'

export const MCSZoneMixinProperties = [
  {
    type: 'string',
    label: 'zone',
    name: 'zone'
  }
]

export function MCSZoneMixin<TBase extends Constructor<MCSUnit>>(Base: TBase): any {
  return class extends Base {
    get zone(): string | undefined {
      return
    }

    set zone(zone: string | undefined) {
      this.zone = zone
    }
  }
}
